import React from 'react';
import type { AttentionItem } from '@shared/competitionAttention';

interface CompetitionAttentionPanelProps {
  items: AttentionItem[];
  /** Navigates to the competition (the existing adjudication/setup navigation pattern). */
  onSelect: (eventId: string) => void;
}

/**
 * Needs attention (#92 F2): a plain list of competitions needing a human,
 * fed by `getCompetitionAttentionItems`. Renders nothing when the list is
 * empty, so it never clutters the admin home or the competitions list on a
 * clean day.
 */
const CompetitionAttentionPanel: React.FC<CompetitionAttentionPanelProps> = ({ items, onSelect }) => {
  if (items.length === 0) return null;

  return (
    <div className="mb-6 rounded-lg border border-amber-200 bg-amber-50 p-4 shadow sm:p-6">
      <h2 className="text-lg font-bold text-gray-900">Needs attention ({items.length})</h2>
      <ul className="mt-3 space-y-2">
        {items.map((item) => (
          <li key={item.eventId}>
            <button
              type="button"
              onClick={() => onSelect(item.eventId)}
              className="min-h-[44px] w-full rounded-md border border-amber-300 bg-white px-3 py-2 text-left text-sm text-gray-800 hover:bg-amber-100 focus:outline-none focus:ring-2 focus:ring-fishing-blue"
            >
              {item.message}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CompetitionAttentionPanel;
